import React from 'react'
import type { TextFieldProps as MuiTextFieldProps } from '@material-ui/core/TextField'
import MuiTextField from '@material-ui/core/TextField'

export type TextFieldProps = MuiTextFieldProps

const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>(function TextField(props, ref) {
  return <MuiTextField ref={ref} {...props} />
})

export default TextField
